export default __webpack_public_path__ + "static/media/DEEP-OCEAN-SHARK-CARTILAGE-300.bb4c7756.jpg";